export default __webpack_public_path__ + "static/media/IMG_20362.34ec632a.jpg";